var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_659_131222)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.652344,
    width: 38,
    height: 36,
    rx: 18,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4091 24.7977C22.8306 24.7977 22.3388 24.6059 21.9339 24.2223C21.5289 23.8387 21.3265 23.3728 21.3265 22.8248C21.3265 22.748 21.3322 22.6685 21.3438 22.586C21.3554 22.504 21.3727 22.4302 21.3959 22.3644L16.5018 19.668C16.3051 19.8324 16.0853 19.9611 15.8423 20.054C15.5993 20.1474 15.3448 20.1941 15.0787 20.1941C14.5002 20.1941 14.0085 20.0023 13.6035 19.6187C13.1986 19.235 12.9961 18.7692 12.9961 18.2211C12.9961 17.6731 13.1986 17.2072 13.6035 16.8236C14.0085 16.44 14.5002 16.2482 15.0787 16.2482C15.3448 16.2482 15.5993 16.2946 15.8423 16.3876C16.0853 16.481 16.3051 16.6099 16.5018 16.7743L21.3959 14.0779C21.3727 14.0121 21.3554 13.9382 21.3438 13.8562C21.3322 13.7738 21.3265 13.6942 21.3265 13.6175C21.3265 13.0695 21.5289 12.6036 21.9339 12.22C22.3388 11.8363 22.8306 11.6445 23.4091 11.6445C23.9876 11.6445 24.4793 11.8363 24.8842 12.22C25.2892 12.6036 25.4916 13.0695 25.4916 13.6175C25.4916 14.1656 25.2892 14.6314 24.8842 15.015C24.4793 15.3987 23.9876 15.5905 23.4091 15.5905C23.1429 15.5905 22.8884 15.5438 22.6454 15.4504C22.4025 15.3575 22.1826 15.2288 21.9859 15.0644L17.0919 17.7608C17.115 17.8265 17.1324 17.9004 17.1439 17.9824C17.1555 18.0648 17.1613 18.1444 17.1613 18.2211C17.1613 18.2979 17.1555 18.3772 17.1439 18.4592C17.1324 18.5416 17.115 18.6157 17.0919 18.6815L21.9859 21.3779C22.1826 21.2135 22.4025 21.0846 22.6454 20.9912C22.8884 20.8983 23.1429 20.8518 23.4091 20.8518C23.9876 20.8518 24.4793 21.0436 24.8842 21.4272C25.2892 21.8109 25.4916 22.2767 25.4916 22.8248C25.4916 23.3728 25.2892 23.8387 24.8842 24.2223C24.4793 24.6059 23.9876 24.7977 23.4091 24.7977Z",
    fill: "url(#paint0_linear_659_131222)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_659_131222",
    x: -4.5,
    y: -4.34766,
    width: 48,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_659_131222"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_659_131222",
    result: "effect2_innerShadow_659_131222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_131222",
    x1: 19.2439,
    y1: 9.27695,
    x2: 19.2439,
    y2: 26.9023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShares);
export default __webpack_public_path__ + "static/media/shares.5b233bd1afcbb31e3a7c98e5a8f5e15c.svg";
export { ForwardRef as ReactComponent };